/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type QueryType = (typeof QueryType)[keyof typeof QueryType];

export const QueryType = {
  report: 'report',
  chart: 'chart',
  user_flow: 'user_flow',
  users_table: 'users_table',
  interactions_table: 'interactions_table',
  user_intelligence: 'user_intelligence',
  classification_rule: 'classification_rule',
  all: 'all',
} as const;
